import React, { Component } from 'react';
import svgLogo from '../assets/logo.svg'
import svgList from '../assets/list.svg';
import svgMail from '../assets/mail.svg';
import Menu from './Menu';
import './Header.css';


class Header extends Component {
  /*constructor (props) {
    super(props);
  }*/

  render() {
    return (
      <header className="app_header">
      <img src={svgLogo} className="svg_logo" alt="HiFineApp" title="HiFineApp" />
      <span className="logo_title">HiFineApp</span>
      <img src={svgList} className={this.props.showMenu?"svg_list svg_list_ext":"svg_list"} alt="Menu" title="Menu" onClick={this.props.onClick} />
      <a href={this.props.mailto}><img src={svgMail} className="svg_mail" alt="Mail" title="Mail" /></a>
      <Menu apps={this.props.apps} showMenu={this.props.showMenu} onClick={this.props.onClick} />
      </header>
    );
  }
}

export default Header;
